import about from "../../assets/about.jpg";

function WhoNWhat() {
    return ( 
        <>
            <section className="who-n-what">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-5">
                            <div className="image">
                                <img src={about} alt="" />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-7">
                            <div className="heading">
                                <span className="color">Who we are</span> and what we do
                            </div>
                            <div className="text">
                                Our team started producing adult content in 2019, when Onlyfans was not yet as popular. With a dedicated team, working around the clock in Europe and the USA, our agency very carefully selects models for successful promotion and management on the platform.
                                <br /><br />
                                <span className="color">But how exactly do we do this?</span>
                                <br /><br />
                                Let's say you decided that you want to become a model, but you don't know how to start. Or you created an onlyfans, started uploading content, but there are no fans, no activity, and, accordingly, no sales either. This is where we come in and develop a production strategy. At the same time, following our technical specifications, you prepare the content that we need for packaging accounts, promotion, and sales on the platform.
                                <br /><br />
                                After which we begin to implement the strategy and pass the questionnaire to the chatters, under the guidance of a senior Quality Assurance manager and analyst.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default WhoNWhat;